import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unsavedChanges: {
		id: 'software-releases-approvers.common.textarea-input.unsaved-changes',
		defaultMessage: 'Unsaved changes',
		description: "Label that indicates there's a unsaved draft changes",
	},
});
